module.exports = __webpack_public_path__ + "img/icon (5).6ce71173.png";